$(document).ready(function () {
  const endDate = new Date('2024-12-01T23:59:59-05:00');

  function updateCountdown() {
    const now = new Date();
    const timeDifference = endDate - now;

    if (timeDifference <= 0) {
      $(".lp_countdown .time_number").text("00");
      return;
    }

    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    $(".lp_countdown .days").text(days.toString().padStart(2, "0"));
    $(".lp_countdown .hours").text(hours.toString().padStart(2, "0"));
    $(".lp_countdown .minutes").text(minutes.toString().padStart(2, "0"));
    $(".lp_countdown .seconds").text(seconds.toString().padStart(2, "0"));
  }
  
  setInterval(updateCountdown, 1000);
  updateCountdown();
});